<template>
    <AppBase>
        <v-card flat tile class="ma-3 pa-3">
            <v-img class="mx-auto" :max-width="200" :src="require('@/assets/logo.png')" alt="MyPEEPS Logo"></v-img>
            <v-card-text>
                <v-form @submit.prevent="submit">
                    <p class="text-h4 text-center">MyPEEPS</p>
                    <div class="primary--text text-xs-center" v-if="forgot">Enter your email address</div>
                    <v-text-field prepend-inner-icon="mdi-email" v-model.trim="email" label="Email" type="email" v-if="!resetToken"></v-text-field>
                    <div class="primary--text text-xs-center" v-if="resetToken">Enter your new password</div>
                    <v-text-field prepend-inner-icon="mdi-lock" v-model="password" label="Password" type="password" v-if="!forgot"></v-text-field>
                    <div class="mt-3 d-flex align-center">
                        <v-btn color="primary" type="submit" :disabled="!canSubmit"><v-icon left>mdi-login</v-icon>{{ resetToken || forgot ? 'Submit' : 'Log In' }}</v-btn>
                        <v-spacer></v-spacer>
                        <div class="" v-if="!resetToken && !forgot">
                            <a href @click.prevent="forgotPassword()">Forgot password?</a>
                        </div>
                    </div>
                    <div class="mt-3 text-center error--text empty-height">{{ error }}</div>
                </v-form>
            </v-card-text>
        </v-card>
    </AppBase>
</template>

<script>
    import AppBase from '@/components/AppBase';
    import { trim } from 'lodash';

    export default {
        name: 'Login',
        components: { AppBase },
        data() {
            return {
                resetToken: null,
                forgot: false,
                error: '',
                email: '',
                password: ''
            };
        },
        computed: {
            canSubmit() {
                if (this.resetToken) {
                    return this.password;
                } else if (this.forgot) {
                    return this.email;
                }
                return this.email && this.password;
            }
        },
        mounted() {
            if (this.$route.query.forgot) {
                this.resetToken = this.$route.query.forgot;
            } else if (this.$route.query.register) {
                this.resetToken = this.$route.query.register;
            }
        },
        methods: {
            forgotPassword() {
                this.error = '';
                this.forgot = true;
            },
            async submit() {
                this.error = '';

                if (this.resetToken) {
                    if (trim(this.password || '').length < 8) {
                        this.error = 'Password must be at least 8 characters long';
                        this.password = '';
                        setTimeout(() => {
                            this.error = '';
                        }, 5000);
                        return;
                    }
                    this.$api
                        .post(`/forgot/${this.resetToken}`, { password: this.password })
                        .then((response) => {
                            this.resetToken = null;
                            this.email = response.data.email || '';
                            this.password = '';
                            this.error = 'Your password has been updated, please log in with your email and new password';
                            setTimeout(() => {
                                this.error = '';
                            }, 5000);
                        })
                        .catch(() => {
                            this.error = 'Unable to update password, your link may have expired';
                            this.password = '';
                            setTimeout(() => {
                                window.location.replace('/');
                            }, 5000);
                        });
                } else if (this.forgot) {
                    this.$api
                        .post('/forgot', { email: this.email })
                        .then(() => {
                            this.email = '';
                            this.password = '';
                            this.error = 'If you have a valid MyPEEPS account, you will receive a password reset link via email';
                            setTimeout(() => {
                                this.forgot = false;
                                this.error = '';
                            }, 5000);
                        })
                        .catch(() => {
                            this.email = '';
                            this.password = '';
                            this.error = 'Unable to request password reset';
                            setTimeout(() => {
                                this.forgot = false;
                                this.error = '';
                            }, 5000);
                        });
                } else {
                    this.$api
                        .post('/login', { email: this.email, password: this.password })
                        .then(() => {
                            window.location.replace('/');
                        })
                        .catch((error) => {
                            this.error = error.response.data;
                        });
                }
            }
        }
    };
</script>
